export default function XSD_String() {
  return (
    <div>
      <h1>XSD_String</h1>
      <p>This is the XSD_String component.</p>
    </div>
  );
}